export default __webpack_public_path__ + "static/media/291.7cfa613c.gif";